import Ratings from './Ratings'
import RatingsHeader from './RatingsHeader'
import RatingsHelp from './RatingsHelp'

export default {
  default: Ratings,
  header: RatingsHeader,
  help: RatingsHelp,
}
